import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import RichText from 'legacy-src/utility/RichText';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';

class Feedback extends Component {
  static propTypes = {
    item: PropTypes.object,
    submission: PropTypes.object,
    feedback: PropTypes.object,
    status: PropTypes.object,
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.canRetry = this.canRetry.bind(this);
    this.retry = this.retry.bind(this);
  }

  canRetry() {
    const { retries = 0 } = this.props.item.content;
    const { submitted, attempts = [] } = this.props.submission.state;

    return (
      submitted && !this.props.feedback.complete && attempts.length < retries
    );
  }

  retry() {
    if (this.canRetry()) {
      const { submission } = this.props;
      const { selection, attempts = [] } = submission.state;
      const newAttempts = attempts.slice();
      newAttempts.push(selection);
      submission.setState({
        submitted: false,
        attempts: newAttempts,
        selection: null,
      });
    }
  }

  render() {
    const { feedback } = this.props;

    return (
      <div>
        {feedback.feedback ? (
          <div
            className={cn('feedback', {
              'feedback--correct': feedback.correct,
            })}
          >
            <RichText content={feedback.feedback} />
          </div>
        ) : null}
        {this.canRetry() ? (
          <ButtonWithIcon isSecondary icon="arrow_circle" onClick={this.retry}>
            Retry
          </ButtonWithIcon>
        ) : null}
      </div>
    );
  }
}

export default Feedback;
